export default __webpack_public_path__ + "static/media/wedding.8ae3fbd9.svg";